<div class="dialog-header">
  <button
    class="close-button"
    mat-icon-button
    tabindex="-1"
    cdkFocusInitial
    (click)="closeDialog(false)"
  >
    <i class="bosch-ic bosch-ic-clickable bosch-ic-close"></i>
  </button>
</div>

<div class="dialog-content">
  <form [formGroup]="modalForm">
    <div class="row-fx-legacy">
      <mat-form-field>
        <mat-label>{{ "input-approval-code" | translate }}</mat-label
        ><input matInput formControlName="approvalCode" />
        <mat-error
          translate
          *ngIf="
            modalForm.get('approvalCode').touched &&
            modalForm.get('approvalCode').hasError('required')
          "
          >required-approval-code</mat-error
        >
      </mat-form-field>
    </div>
    <div class="row-fx-legacy">
      <mat-form-field>
        <mat-label>{{ "input-cost-center" | translate }}</mat-label
        ><input
          matInput
          formControlName="costCenter"
          [mask]="getCostCenterMask()"
        />
      </mat-form-field>
    </div>
    <div class="row-fx-legacy">
      <mat-form-field>
        <mat-label>{{ "input-notes" | translate }}</mat-label
        ><textarea
          matInput
          maxlength="65000"
          formControlName="observation"
        ></textarea>
      </mat-form-field>
    </div>
  </form>
</div>

<div class="dialog-actions">
  <button
    class="sample-button sample-button--primary"
    (click)="closeDialog(true)"
    [disabled]="modalForm.invalid"
  >
    {{ "input-aprove" | translate }}
  </button>
</div>
